import { z } from 'zod';

export const TrueFalse = z.boolean();

export type TrueFalse = z.infer<typeof TrueFalse>;
